"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientSelectWrapper = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var Fade_1 = (0, tslib_1.__importDefault)(require("react-reveal/Fade"));
var ClientSelect_1 = require("./ClientSelect");
var _1 = require(".");
var NoClients_1 = (0, tslib_1.__importDefault)(require("./NoClients"));
var AuthenticateLoader_1 = (0, tslib_1.__importDefault)(require("../components/AuthenticateLoader"));
var ClientSelectWrapper = function (_a) {
    var children = _a.children;
    var _b = (0, _1.useClients)(), clients = _b.clients, selectedClient = _b.selectedClient, selectClient = _b.selectClient, loading = _b.loading;
    if (loading) {
        return react_1.default.createElement(AuthenticateLoader_1.default, { text: "Signing In..." });
    }
    if (clients && clients.length === 0) {
        return (react_1.default.createElement(StyledContainer, null,
            react_1.default.createElement(Fade_1.default, null,
                react_1.default.createElement(NoClients_1.default, null))));
    }
    if (!selectedClient) {
        return (react_1.default.createElement(StyledContainer, null,
            react_1.default.createElement(Fade_1.default, null,
                react_1.default.createElement(ClientSelect_1.ClientSelect, { clients: clients, selectClient: selectClient }))));
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.ClientSelectWrapper = ClientSelectWrapper;
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  height: 100vh;\n"], ["\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  height: 100vh;\n"])));
var templateObject_1;
